"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OFFSET_MAP = void 0;
var OFFSET_MAP = {
  usual: {
    left: {
      offsetLeft: '0px',
      offsetRight: '0px'
    },
    right: {
      offsetLeft: '0px',
      offsetRight: '0px'
    }
  },
  iconButton: {
    left: {
      offsetLeft: '-0.4375rem',
      offsetRight: '0px'
    },
    right: {
      offsetLeft: '0px',
      offsetRight: '-0.4375rem'
    }
  }
};
exports.OFFSET_MAP = OFFSET_MAP;